<template>
  <div>
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="お役立ちコラム" />
    <div v-html="htmlContent"></div>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import Breadcrumb from '@/components/modules/Breadcrumb'

export default {
  components: {
    HeaderBanner,
    Breadcrumb,
  },
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: 'お役立ちコラム',
            path: 'https://b-call.jp/columns',
          },
        ],
      }
    },
  },
  title() {
    return this.columnMap[this.no].title
  },
  meta() {
    return this.columnMap[this.no].meta
  },
  data() {
    return {
      htmlContent: '',
      no: this.$route.params.no,
      columnMap: {
        1: {
          title:
            '【病院関係者向け】待ち時間対策の重要性や効果的な方法を解説！｜B-Call（ビーコール）',
          meta:
            '患者さんにとって「診療までの待ち時間」は大きなストレスを感じる時間となるため、病院側は待ち時間に関する何らかの対策が必要です。当記事では、平均的な診療までの待ち時間・待ち時間を短縮するメリット・待ち時間短縮に有効な方法を解説しています。',
        },
        2: {
          title:
            'ナースコールの使い方を4つのタイプ別に解説！活用のポイントも｜B-Call（ビーコール）',
          meta:
            '入院患者さんや介護施設の利用者にとって、緊急時に医師や看護師を呼び出せる重要な設備が「ナースコール」です。当記事では、ナースコールの概要や代表的なタイプと使い方、さらに活用時のポイントを徹底的に解説しています。',
        },
        3: {
          title:
            '【飲食店向け】待ち時間が発生する際のお客様への対応と時短アイデア｜B-Call（ビーコール）',
          meta:
            'この記事では、飲食店における待ち時間の長さとお客様の満足度の関係性から、待ち時間が発生した場合の対処・待ち時間を短縮するためのアイデアまでを詳しく解説します。待ち時間に関するクレームや、回転率アップに悩む方はぜひ参考にしてください。',
        },
        4: {
          title:
            '飲食店の回転率を上げるべき理由は？用語の意味から改善策まで！｜B-Call（ビーコール）',
          meta:
            'この記事では、飲食店の経営に携わる人に向けて、回転率について解説します。回転率の基本的な意味・関連用語の他、回転率をアップする方法・売上アップのコツなどを把握し、ぜひお店の業務改善に生かしてください。',
        },
        5: {
          title:
            'ナースコールを押しやすい環境づくりの方法を5パターンに分けて解説｜B-Call（ビーコール）',
          meta:
            'この記事では、ナースコールを押しやすい環境づくりの方法を身体的・心理的な面から5パターンに分けて解説します。ナースコールが活用されず、トラブルが起きることを避けたい医療スタッフの方はぜひ参考にしてください。',
        },
        6: {
          title:
            '物流倉庫におけるオペレーションの効率化｜工程ごとにポイントを解説｜B-Call（ビーコール）',
          meta:
            'この記事では、物流倉庫におけるオペレーションの効率化について、重要性から工程ごとの効率化のポイントまでを詳しく解説します。近年需要が高まる一方で、人手不足が深刻化している物流業界において、業務改善に取り組みたい方はぜひ参考にしてください。',
        },
        7: {
          title:
            'フードコートの呼び出しベルの仕組みは？よくある疑問とおすすめ機種｜B-Call（ビーコール）',
          meta:
            '当記事では、フードコートで活用されている呼び出しベルについて、仕組みや利用の流れなどを詳しく解説します。呼び出しベルにまつわるQ＆Aも紹介するため、呼び出しベルの導入を検討中の方は、ぜひ参考にしてください。',
        },
        8: {
          title:
            '業務・環境改善で工場トラブルを減らす！代表的なトラブルと対処法も｜B-Call（ビーコール）',
          meta:
            '工場は日々、設備・品質・安全のトラブルのリスクにさらされています。この記事では、工場で起きるトラブルを業務・環境改善で減らす方法を紹介します。トラブル対策に悩む、経営者や管理者の方は、ぜひ参考にしてください。',
        },
        9: {
          title:
            'アンドンとは？生産ラインで重視される理由や種類・運用のポイントも｜B-Call（ビーコール）',
          meta:
            '生産性向上や業務改善の目標を掲げる、工場の運営に携わる方に向けて、アンドンとは何かを具体的に解説します。種類・活用例や重視される理由、運用時のポイント、おすすめの無線アンドンなどもご紹介しますので、ぜひご覧ください。',
        },
        10: {
          title:
            'ワイヤレスチャイムが鳴らない5つの理由｜トラブルの少ない機種も｜B-Call（ビーコール）',
          meta:
            'ワイヤレスチャイムが鳴らない理由として、チャイムの不具合や設置環境が考えられます。この記事では、チャイムが鳴らない5つの理由を解説したのち、トラブルが少ない機種の選び方やおすすめの機種をご紹介します。',
        },
        11: {
          title:
            '待合室に呼び出しベルを導入して混雑を緩和！使い方や導入のポイントも｜B-Call（ビーコール）',
          meta:
            '待合室の混雑緩和に有効なのが呼び出しベルです。導入することで、感染防止対策や患者さんのストレス緩和、スタッフの業務改善にも役立ちます。導入するときのポイントや効果的な使い方を、おすすめの機種と併せて紹介します。',
        },
        12: {
          title:
            '駐車場での呼び出しベル活用例5選！導入の注意点とおすすめ機種も｜B-Call（ビーコール）',
          meta:
            '呼び出しベルを使用すると、待ち時間を駐車場で過ごすお客様を簡単に呼び出すことができます。さまざまな店舗での呼び出しベル活用例と、導入する際の注意点を解説します。おすすめ機種も紹介するので、導入を検討している人は参考にしてください。',
        },
        13: {
          title:
            'フードコートの呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            'フードコートの呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        14: {
          title: '工場の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '工場の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        15: {
          title:
            '病院・薬局の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '病院・薬局の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        16: {
          title:
            'イベント・展示会の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            'イベント・展示会の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        17: {
          title:
            '介護・福祉の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '介護・福祉の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        18: {
          title:
            '焼却場・不燃物処理場の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '焼却場・不燃物処理場の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        19: {
          title:
            '物流倉庫の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '物流倉庫の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        20: {
          title:
            'カー用品店の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            'カー用品店の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        21: {
          title:
            '屋外施設の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '屋外施設の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        22: {
          title:
            '教育施設の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '教育施設の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        23: {
          title:
            '大規模施設の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '大規模施設の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        24: {
          title:
            '飲食店の呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
          meta:
            '飲食店の呼び出しベルについてのページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
        },
        26: {
          title:
            'ボタンを押したらスマホに通知が来るシステムとは？必要な機能も｜B-Call（ビーコール）',
          meta:
            'この記事では、職場に呼び出しボタンを設置する場合に必要な機能について、詳しく解説します。また、ボタンを押したらスマホに通知が来るシステムである「Beyond EC」についても取り上げるので、ぜひご覧ください。',
        },
        27: {
          title:
            '業務用のワイヤレス呼び出しベルの選び方｜導入メリットも解説｜B-Call（ビーコール）',
          meta:
            'この記事では、ワイヤレス呼び出しベルの導入メリット、および飲食店・工場・病院・介護施設の4つの業種別にワイヤレス呼び出しベルの選び方を解説します。自社にワイヤレス呼び出しベルの導入を考えている方は、ぜひこの記事を参考にしてください。',
        },
        28: {
          title:
            '工場で改善提案に使えるネタ4選｜改善を成功させるポイントも解説｜B-Call（ビーコール）',
          meta:
            '工場の改善提案を成功させるためのネタ4選を紹介します。備品の管理方法の変更や、レイアウトの見直し、日報の電子化、指示のやり方の改善など、具体的なアイデアとともに、実施のポイントも詳しく解説しています。',
        },
        29: {
          title:
            '病院で「待ち時間が長い」とクレームが来たときの対応方法を解説｜B-Call（ビーコール）',
          meta:
            '病院を運営する上で、待ち時間に対するクレームは発生しやすい問題です。待ち時間が長いとクレームがあった際に対応するためのステップや、待ち時間を短縮する対策について紹介します。',
        },
        30: {
          title:
            '飲食店のオペレーションとは？効率よく改善するためのポイントを解説｜B-Call（ビーコール）',
          meta:
            '飲食店にとって、オペレーションの改善は非常に重要です。当記事では、飲食店におけるオペレーションの概要と重要性・3つの分類と改善策・改善ポイント・オペレーション効率アップに適した呼び出し3つのベル商品を徹底解説しています。',
        },
        31: {
          title:
            '物流倉庫の業務を改善するポイントとは？改善提案の見つけ方も解説｜B-Call（ビーコール）',
          meta:
            '当記事では、物流倉庫の業務効率化を図るためのポイントと具体的な改善方法、改善提案が見つからない・思いつかないときの考え方、さらに物流業務の改善に役立つ商品を徹底解説しています。改善提案を求められている現場担当者の方は、ぜひご覧ください。',
        },
        32: {
          title:
            '患者呼び出しシステムとは？導入メリットや選ぶポイントを紹介｜B-Call（ビーコール）',
          meta:
            'スタッフ・患者さん双方の負担軽減を目的に「患者呼び出しシステム」を導入する医療機関が増加しています。当記事では、呼び出しシステムの概要・導入メリット・システム選びのポイント・おすすめの患者呼び出しシステムを徹底解説しています。',
        },
        33: {
          title:
            'イベントの混雑を緩和する方法とは？入退場・飲食ブースの対策を解説｜B-Call（ビーコール）',
          meta:
            'この記事ではイベントの混雑を緩和するやり方として、混雑しやすい入退場口および飲食ブースの混雑緩和方法を解説します。展示会やイベントを開催予定の方は、この記事を参考にしてください。',
        },
        34: {
          title:
            '介護施設にナースコールが必要な理由｜設置基準・選び方も解説！｜B-Call（ビーコール）',
          meta:
            '介護施設にナースコールが必要とされる理由について詳しく解説します。さらに、ナースコールを適切に設置しない場合のリスクや、ナースコールの選び方についても取り上げるので、ぜひ参考にしてください。',
        },
        35: {
          title:
            '工場における呼び出しシステムの活用シーン｜導入メリット・選び方も｜B-Call（ビーコール）',
          meta:
            '工場における呼び出しシステムの活用シーンについて、詳しく解説します。さらに、工場に呼び出しシステムを導入するメリットや、システムを選ぶ際のポイントについても取り上げるので、ぜひご覧ください。',
        },
        36: {
          title:
            '工場で「呼びたい人が近くにいない」悩みを解決できる呼び出しベル｜B-Call（ビーコール）',
          meta:
            '工場向けの呼び出しベルを活用すれば、「担当者を呼びたいのに、近くにいない」という問題に対応できるでしょう。製造現場に合った呼び出しベルの選び方を解説します。',
        },
        37: {
          title:
            '作業中の呼び出しに気付けない！工場の悩みを解決できる呼び出しベル｜B-Call（ビーコール）',
          meta:
            '当記事では、工場勤務で「作業中の呼び出しに気付けない」という悩みを抱えている方に向けて、作業中の呼び出しに気付きにくい理由や解決方法を解説します。',
        },
        38: {
          title:
            '生産ラインの効率が悪いときの解決法｜呼び出しベルで生産性アップ！｜B-Call（ビーコール）',
          meta:
            'この記事では工場の生産ラインの効率化や最適化に悩んでいる方に向けて、設備トラブルやチョコ停への効率的な対応に活用できる呼び出しベルの活用方法を解説します。',
        },
        39: {
          title:
            '無人運転中の機械トラブルに気付けない！呼び出しベルでお悩み解決｜B-Call（ビーコール）',
          meta:
            '当記事では、無人運転中の機械トラブルに気付けない問題に直面している方に向けて、呼び出しベルを導入するメリットやおすすめの呼び出しベルを3つ紹介します。',
        },
        40: {
          title:
            '患者様へのプライバシー保護に配慮したい方におすすめの呼び出しベル｜B-Call（ビーコール）',
          meta:
            'このページでは病院やクリニックの受付担当の方に向けて、患者様のプライバシー保護に配慮しながらしっかりと呼び出しが分かりやすい、おすすめの呼び出しベルを紹介します。',
        },
        41: {
          title:
            '待合室が混み合っている状況を解決したいなら呼び出しベルが効果的｜B-Call（ビーコール）',
          meta:
            'この記事では、待合室が混雑している状況を解決したい病院やクリニックの担当者様に向けて、混雑解消に向いた機能を持つ呼び出しベル2つを紹介します。',
        },
        42: {
          title:
            'お客様の呼び声に気付けないときにおすすめの呼び出しベルを紹介｜B-Call（ビーコール）',
          meta:
            'この記事では、お客様の呼び出しに気付けない、見逃してしまう、といった状況に悩む飲食店のオーナーに向けて、最適な呼び出しベルの選び方と、おすすめの製品を紹介します。',
        },
        43: {
          title:
            'ペット同士でトラブルになるのを防げる呼び出しベルの選び方を解説｜B-Call（ビーコール）',
          meta:
            'ペット同士のトラブルを防ぐためには、飼い主様が病院外でも待てるような呼び出しベルを導入するのがおすすめです。動物病院に向いた呼び出しベル2製品を紹介します。',
        },
        44: {
          title:
            '人件費を削減したい飲食店に呼び出しベルの導入がおすすめな理由｜B-Call（ビーコール）',
          meta:
            'この記事では人件費を削減したい飲食店向きに、呼び出しベルの導入がおすすめの理由や呼び出しベルの選び方、オペレーション効率化に向いた機種を紹介します。',
        },
        45: {
          title:
            '待ち列ができて混雑してしまう飲食店には呼び出しベル導入がおすすめ｜B-Call（ビーコール）',
          meta:
            '呼び出しベルは行列や混雑の解消にも有効です。この記事では待ち列ができて混雑してしまう飲食店やフードコートに向いた、呼び出しベルの選び方やおすすめの機種を紹介します。',
        },
        46: {
          title:
            'ドライバーが長時間労働になっている物流業界向け呼び出しベルを紹介｜B-Call（ビーコール）',
          meta:
            '2024年問題が深刻化する中で、荷待ち時間減少などの効率化は必須事項です。この記事では、ドライバーの労働時間を改善するために効果的な呼び出しベルについて紹介します。',
        },
        47: {
          title:
            'トラックバースの回転率が悪いときに効果的な呼び出しベルを紹介｜B-Call（ビーコール）',
          meta:
            'トラックバースの回転率向上は、2024年問題への対策として重要です。音だけでなく、バイブレーションや光、メッセージで呼び出せる呼び出しベルを導入し、回転率を上げましょう。',
        },
        48: {
          title:
            '医師・看護師がどこにいるのか分からないなら呼び出しベルがおすすめ｜B-Call（ビーコール）',
          meta:
            '医師や看護師がどこにいるのか分からず、探すのに無駄な時間がかかっている場合、呼び出しベルの導入で業務を効率化できます。病院・クリニック向きの呼び出しベルを紹介します。',
        },
        49: {
          title:
            '離れた駐車場で待つ患者さんを呼び出したいときに便利な呼び出しベル4選｜B-Call（ビーコール）',
          meta:
            '感染対策として患者さんに離れた駐車場で待ってもらっている場合、呼び出すのに手間がかかります。駐車場の患者さんを呼び出すのに向いた呼び出しベル4種類を紹介します。',
        },
        50: {
          title:
            '受付の呼び出しに気付いてもらえないときは呼び出しベルがおすすめ｜B-Call（ビーコール）',
          meta:
            '利用者が多い時間帯や特定の手続きが集中する時期には、市役所などの受付は混雑し、呼び出しに気づいてもらえない可能性が高くなります。混雑解消のためにも、呼び出しベルを導入し、受付の呼び出しに気づいてもらいましょう。',
        },
        51: {
          title:
            'レジでお客様を待たせてしまう悩みを解決する呼び出しベルとは｜B-Call（ビーコール）',
          meta:
            'スタッフがレジから離れている際にお客様に気付かず、待たせてしまうという課題を抱えているなら、呼び出しベルの導入がおすすめです。レジ待ち解消に効果的な呼び出しベルについて詳しく紹介します。',
        },
        52: {
          title:
            'オフィスで簡単に人を呼び出したいときに使える呼び出しベルとは｜B-Call（ビーコール）',
          meta:
            '受付に来たお客様を待たせてしまったり、商談中に離席して人を呼び出す状況が発生したりしている場合、呼び出しベルを活用するのがおすすめです。オフィス向きの呼び出しベルの選び方を解説します。',
        },
        53: {
          title:
            '順番待ちのお客様を呼び出したいアミューズメント施設向きのツールとは｜B-Call（ビーコール）',
          meta:
            'お客様がアミューズメント施設内の好きな場所で待てるようにしつつ、呼び出しやすくするためには呼び出しベルがおすすめです。アミューズメント施設向けの呼び出しベルを紹介します。',
        },
        54: {
          title:
            '「先生を呼びたいけど近くにいない」という悩みを解決する呼び出しベル｜B-Call（ビーコール）',
          meta:
            '「先生を呼びたいけど近くにいない」と悩んでいる生徒を抱える学習塾や教育機関向けに、使いやすい呼び出しベルを紹介します。質問しやすい環境を作りたい方は、ぜひ参考にしてください。',
        },
        55: {
          title:
            '試着室からの呼び出しに気付けないなら呼び出しベル導入がおすすめ｜B-Call（ビーコール）',
          meta:
            '試着室からの呼び出しに気付けない場合は、音だけでなく光や振動でも呼び出せる',
        },
        56: {
          title:
            '店員が捕まらず購入を諦めるお客様がいるなら呼び出しベルの導入を｜B-Call（ビーコール）',
          meta:
            '呼び出しベルには工事不要で設置できる製品も多く、お客様がスタッフを呼び出す以外にも、サービスの順番待ちをしているお客様の呼び出しにも活用できます。ホームセンターや家電量販店に向いた呼び出しベルについて解説します。',
        },
      },
    }
  },
  mounted: function() {
    this.loadHtml()
  },
  methods: {
    loadHtml() {
      fetch('/static/columns/' + this.no + '/column_' + this.no + '.html').then(
        res => {
          res.text().then(html => {
            this.htmlContent = html
          })
        }
      )
    },
  },
}
</script>

<style>
/* BASE ~ AGENDA */

.column_wrap {
  padding: 0;
  box-sizing: border-box;
  line-height: 2em;
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.column_wrap .txtbox {
  margin: 1em 0 4em;
}
.column_wrap .txtbox p {
  margin: 0 0 2em;
  line-height: 2em;
}
.column_wrap .banner {
  margin: 2em auto;
  text-align: center;
}
.column_wrap .banner img {
  width: 100%;
  max-width: 850px;
}

.column_wrap .width10 {
  width: 10% !important;
}
.column_wrap .width20 {
  width: 20% !important;
}
.column_wrap .width30 {
  width: 30% !important;
}
.column_wrap .width40 {
  width: 40% !important;
}
.column_wrap .width50 {
  width: 50% !important;
}
.column_wrap .width60 {
  width: 60% !important;
}
.column_wrap .width70 {
  width: 70% !important;
}
.column_wrap .width80 {
  width: 80% !important;
}
.column_wrap .width90 {
  width: 90% !important;
}
.column_wrap .width100 {
  width: 100% !important;
}
.column_wrap .width33 {
  width: 33.3% !important;
}
.column_wrap .width25 {
  width: 25% !important;
}
.column_wrap .width35 {
  width: 35% !important;
}
.column_wrap .width65 {
  width: 65% !important;
}
.column_wrap .width75 {
  width: 75% !important;
}
.wauto {
  width: auto !important;
}

.column_wrap .mb0 {
  margin-bottom: 0 !important;
}
.column_wrap .mb1em {
  margin-bottom: 1em !important;
}
.column_wrap .mb2em {
  margin-bottom: 2em !important;
}
.column_wrap .mt0 {
  margin-top: 0 !important;
}
.column_wrap .pb0 {
  padding-bottom: 0 !important;
}
.column_wrap .pb1em {
  padding-bottom: 1em !important;
}
.column_wrap .pb2em {
  padding-bottom: 2em !important;
}
.column_wrap .text_right {
  text-align: right !important;
}
.column_wrap .text_left {
  text-align: left !important;
}
.column_wrap .text_center {
  text-align: center !important;
}

.column_wrap .txtbox p.mb0 {
  margin-bottom: 0 !important;
}
.column_wrap .txtbox p.mb1em {
  margin-bottom: 1em !important;
}
.column_wrap .txtbox p.mb2em {
  margin-bottom: 2em !important;
}
.column_wrap .txtbox p.mt0 {
  margin-top: 0 !important;
}

.column_wrap .pageindex {
  max-width: 620px;
  margin: 1.5em auto 6em;
  padding: 1.5em 2.5em;
  background: #fff;
  list-style-type: none;
  background: #dceefe;
}
.column_wrap .pageindex p {
  font-size: 1.5em;
  text-align: center;
  margin-bottom: 1em;
  color: #333;
}
.column_wrap .pageindex ol {
  counter-reset: item;
  list-style-type: none;
  padding-left: 0;
}
.column_wrap .pageindex ol li {
  list-style: none !important;
  padding: 0.4em 0;
}
.column_wrap .pageindex ol li ol {
  padding-left: 1em !important;
}
.column_wrap .pageindex ol li:before {
  counter-increment: item;
  content: counters(item, '-') '. ';
}
.column_wrap .pageindex ol li a {
  line-height: 2em !important;
}

.column_wrap a {
  color: #1a57a7;
  text-decoration: none;
  cursor: pointer;
}

.column_wrap a:hover,
.column_wrap a img:hover {
  opacity: 0.7;
  transition: 0.5s;
}

.column_wrap .mauto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.column_wrap .btn a {
  display: block;
  padding: 0.3em 2em;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  background: #50acfc;
  box-shadow: 0 3px 0 #1a93fd;
  font-weight: bold;
}

/* Content */

.column_wrap .main_tt {
  line-height: 1.6em;
  margin: 3em 0 1em;
  letter-spacing: 0.02em;
  color: #333;
  font-size: 2em;
  font-weight: bold;
  padding-left: 15px;
  color: #1a57a7;
  margin: 5px 0;
  border-bottom: 1px solid #1a57a7;
}
.column_wrap .main_tt:before {
  color: #1a57a7;
  content: '■';
  display: inline-block;
}

.column_wrap h3 {
  font-size: 1.5em;
  line-height: 1.6em;
  margin: 0 0 1em;
  padding: 0.5em;
  color: #494949;
  background: #dceefe;
  border-left: solid 8px #1a57a7;
}
.column_wrap h4 {
  font-size: 1.4em;
  margin: 0 0 1em;
  font-weight: bold;
  color: #50acfc;
  padding: 0.3em 0.5em;
  border-bottom: 2px solid #50acfc;
}

.column_wrap .txt_red {
  color: #d94444;
}
.column_wrap .txt_bold {
  font-weight: bold;
}
.column_wrap .txt_ul {
  text-decoration: underline;
}
.column_wrap .txt_size_big {
  font-size: 1.2em;
}

.column_wrap .bg_red {
  background: #fff4f9 !important;
}
.column_wrap .bg_blue {
  background: #edf8ff !important;
}
.column_wrap .bg_green {
  background: #f5ffed !important;
}
.column_wrap .bg_yellow {
  background: #fffef2 !important;
}
.column_wrap .bg_violet {
  background: #fef4ff !important;
}
.column_wrap .bg_orange {
  background: #fbf3e7 !important;
}
.column_wrap .bg_stripe {
  background: -webkit-repeating-linear-gradient(
    -45deg,
    #ffffff,
    #ffffff 3px,
    #f5f5f5 3px,
    #f5f5f5 7px
  ) !important;
  background: repeating-linear-gradient(
    -45deg,
    #ffffff,
    #ffffff 3px,
    #f5f5f5 3px,
    #f5f5f5 7px
  ) !important;
}

.column_wrap .borderbox {
  margin: 2em auto;
  padding: 2em;
  border: 1px solid #a0a0a0;
}
.column_wrap .borderbox p:last-of-type,
.column_wrap .borderbox li:last-of-type {
  margin-bottom: 0 !important;
}

.column_wrap ul {
  list-style-type: none !important;
  padding: 0;
  margin: 0;
}
.column_wrap ol {
  list-style-type: none !important;
  padding: 0;
  margin: 0;
}
.column_wrap .txtbox li {
  list-style: none;
}
.column_wrap .list_dot li {
  list-style: inside circle !important;
  padding: 0;
}
.column_wrap .list_num li {
  list-style: inside decimal !important;
  padding: 0;
}

.column_wrap .listTab table {
  margin: 2em auto;
  border: 1px solid #595959;
  border-collapse: collapse;
}
.column_wrap .listTab table th {
  border: 1px solid #a0a0a0;
  padding: 1em;
  background: #dceefe;
  text-align: center;
}
.column_wrap .listTab table td {
  padding: 1em;
  background: #fff;
  border: 1px solid #a0a0a0;
}
.column_wrap .txtbox .va_m {
  vertical-align: middle !important;
}

.column_wrap .clm_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.column_wrap .clm_box.vtop {
  align-items: flex-start;
}

.column_wrap .clm_box.clm2 > * {
  width: 48%;
}
.column_wrap .clm_box.clm3 > * {
  width: 30%;
}
.column_wrap .clm_box.clm4 > * {
  width: 22%;
}

.column_wrap .bq {
  margin: 2em auto;
  padding: 2em;
  background: #eee;
  border-left: 8px solid #1a57a7;
}
.column_wrap blockquote {
  margin: 0 !important;
  word-break: break-all;
}
.column_wrap q {
  background: #dceefe;
  padding: 0.2em;
}
.column_wrap q::before,
.column_wrap q::after {
  content: '';
}

/* RESPONSIVE */

@media only screen and (min-width: 601px) {
  .column_wrap .pcnone {
    display: none !important;
  }
  .column_wrap .spnone {
    display: block !important;
  }
}

@media only screen and (max-width: 600px) {
  .column_wrap .pcnone {
    display: block !important;
  }
  .column_wrap .spnone {
    display: none !important;
  }
  .column_wrap .banner img {
    width: 100%;
  }
  .column_wrap .listTab table {
    width: 100%;
    word-break: break-all;
  }

  .column_wrap .bq,
  .column_wrap .borderbox {
    padding: 1em;
  }
  .column_wrap .pageindex {
    padding: 1.5em 1em;
  }

  .column_wrap .clm_box.clm4 > * {
    width: 48%;
  }
  .column_wrap .clm_box.spclm1 {
    display: block;
  }
  .column_wrap .clm_box.spclm1 > * {
    width: 100% !important;
  }
  .column_wrap p[id^='a'] {
    padding-top: 100px !important;
    margin: -100px 0 0 !important;
  }
}

.lp_wrap {
  width: 100%;
}
.lp_wrap img {
  width: 100%;
}
.lp_wrap li {
  list-style: none;
}
.lp_wrap a {
  transition: 0.3s;
  text-decoration: none;
  color: #0a518d;
}
.lp_wrap a:hover {
  opacity: 0.8;
}
.lp_wrap .w1000 {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;
}
.lp_wrap section {
  padding: 2%;
}
.lp_wrap .center {
  text-align: center;
}
.lp_wrap .mv {
  background: #d9e6f0;
  width: 100%;
  padding: 0 !important;
}
.lp_wrap .mv .w1000 {
  background-size: contain;
}
.lp_wrap .mv h2 {
  color: #09518d;
  padding: 8% 1%;
  margin: 0;
  font-size: 1.8em;
}
.lp_wrap .tt2 {
  margin: 0;
  color: #0a518d;
}
.lp_wrap .intro .tt2 {
  color: #fff;
}
.lp_wrap .intro {
  background: linear-gradient(#4698e9, #1a57ba);
  color: #fff !important;
}
.lp_wrap .merit {
  text-align: center;
}
.lp_wrap .merit ul,
.lp_wrap .product ul {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 0;
}
.lp_wrap .product ul li strong {
  display: block;
  margin-bottom: 8px;
  font-size: 120%;
}
.lp_wrap .merit ul li {
  margin: 1%;
  width: 30%;
  background: #d7e6f1;
  padding: 3% 2% 1%;
}
.lp_wrap .merit ul li img {
  max-width: 100px;
}
.lp_wrap .merit ul li h3 {
  color: #004d8f;
  margin: 0.5em 0 0;
}
.lp_wrap .merit ul li p {
  font-size: 90%;
}
.lp_wrap .product ul li {
  margin: 1%;
  width: 30%;
  text-align: left;
}
.lp_wrap .product {
  background: #dceefe;
}
.lp_wrap .column_nav {
  text-align: center;
  padding: 3% 2%;
}
.lp_wrap .column_nav ul {
  display: flex;
  padding: 0;
  justify-content: center;
}
.lp_wrap .column_nav h2 {
  margin-bottom: 2%;
}
.lp_wrap .column_nav ul li {
  width: 30%;
  margin: 0 1%;
}
.lp_wrap .column_nav ul li img {
  height: 80px;
  object-fit: fill;
}
.lp_wrap .column_nav ul li h3 {
  margin: 0;
  font-size: 90%;
  text-align: left;
}
.lp_wrap .flexwrap {
  flex-wrap: wrap;
}
.solution.center {
  background: #d7e6f1;
}
@media only screen and (max-width: 600px) {
  .lp_wrap ul {
    flex-wrap: wrap;
  }
  .lp_wrap ul li {
    width: 100% !important;
  }
  .lp_wrap .column_nav ul li img {
    object-fit: inherit;
    height: inherit;
  }
  .lp_wrap .column_nav ul li h3 {
    margin: 2% 0 4%;
  }
  .lp_wrap section {
    padding: 7% 3% !important;
  }
  .lp_wrap .mv h2 {
    width: 50%;
    padding: 5%;
    font-size: 1.5em;
  }
  .lp_wrap .circle-parent {
    display: none;
  }
  .choice-by-industry .industry-scene-list {
    padding: 10px 0 20%;
    grid-template-columns: repeat(2, 45%);
    grid-template-rows: repeat(6, 17%);
  }
  .choice-by-industry .industry-detail-header {
    padding: 0 5% 0 5%;
  }
  .choice-by-industry .industry-detail-header .industry-detail-image {
    display: inline-block;
    height: auto;
    margin-left: 0;
  }
  .choice-by-industry .industry-detail-title .industry-detail-name {
    font-size: 1rem;
    vertical-align: middle;
  }

  .choice-by-industry .industry-detail-description {
    display: none;
  }
}

.industry-scene-choice {
  background-color: rgb(217, 230, 240);
}

.industry-scene-choice-header {
  font-weight: bold;
}

.industry-scene-choice-header.for-in-page {
  font-size: 22px;

  padding: 20px 5% 0 5%;

  text-align: center;

  color: rgb(9, 81, 141);
}

.industry-scene-choice-header.for-in-home {
  padding: 20px 15% 10px 15%;
}

.industry-scene-list {
  display: grid;
  justify-content: center;

  padding: 10px 0 30px;

  grid-template-columns: repeat(4, 210px);
  grid-template-rows: repeat(3, 180px);
  grid-gap: 10px 10px;
}

.industry-scene {
  width: 100%;
  text-decoration: none;

  color: #4d4d4d;
  border: 1px solid #eee;
  background-color: #fff;
}

.industry-scene.for-in-home {
  cursor: pointer;
  pointer-events: auto;
}

.industry-scene .industry-scene-image {
  width: 100%;
  height: auto;

  background-color: rgb(217, 230, 240);
}

.industry-scene .industry-scene-name {
  font-size: 14px;
  font-weight: bold;

  text-align: center;
}

.industry-detail {
  margin-top: 30px;
}

.industry-detail-header {
  display: flex;

  height: 150px;
  margin-bottom: 30px;

  color: white;
  background: linear-gradient(rgb(70, 152, 233), rgb(26, 87, 186));
}

.industry-detail-header .industry-detail-image {
  display: inline-block;

  width: 210px;
  height: 100%;
  margin-left: 15%;
}

.industry-detail-header .industry-detail-title {
  display: inline-block;

  height: 100%;

  vertical-align: top;
}

.industry-detail-header .industry-detail-title .industry-detail-name {
  font-size: 22px;
  font-weight: bold;

  margin: 30px 0 -10px 30px;
}

.industry-detail-header .industry-detail-title .industry-detail-description {
  font-size: 16px;

  margin: 0 0 0 30px;

  white-space: pre-line;
}

.industry-detail-body {
  display: flex;
  flex-wrap: wrap;

  max-width: 900px;
  margin: 0 auto;
}

.industry-detail-body .candidate-product {
  width: auto;
  height: 200px;
  margin: 10px 20px;
}

.industry-detail-body .candidate-product img {
  width: auto;
  height: 100%;
}

.other-products .other-products-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;

  border: 2px solid gray;
  border-radius: 4px;
}

.other-products .product-thumbnails {
  display: flex;
  flex-wrap: wrap;
  margin: 0 25px;
}

.other-products .product-thumbnails .product-thumbnail {
  width: auto;
  height: 170px;
  margin: 10px 10px;
}

.other-products .product-thumbnails .product-thumbnail img {
  width: auto;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Column.vue